import React, { useState } from "react"; // fixed — was missing useState
import { Box, Paper, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import { useSelector } from "react-redux";
import { INSIGHTS_LOOKUP, InsightTile } from "./InsightsView";
import { BreakdownRouter } from "./Breakdown"; // added — was missing entirely
import { BORDER, TEXT_HEADING, TEXT_MUTED, BRAND_BLUE } from "./designTokens";
import { useRelativeTimeTick } from "./utils/useRelativeTimeTick";

const MAX_PINNED_TILES = 5;

function AddMoreInsightsCard({ onBrowseInsights }) {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: "1 1 0",
        minWidth: 0,
        p: 3,
        border: `1px dashed #C7D2E8`,
        borderRadius: 2.5,
        bgcolor: "#F8FAFF",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          bgcolor: "#EEF2F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <InsightsOutlinedIcon sx={{ fontSize: 20, color: TEXT_MUTED }} />
      </Box>

      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: TEXT_HEADING }}>
        Add more insights
      </Typography>

      <Button
        variant="contained"
        size="small"
        startIcon={<AddIcon sx={{ fontSize: 16 }} />}
        onClick={onBrowseInsights}
        sx={{
          mt: 0.5,
          textTransform: "none",
          fontWeight: 600,
          fontSize: 12.5,
          bgcolor: BRAND_BLUE,
          boxShadow: "none",
          "&:hover": { bgcolor: "#0D47A1", boxShadow: "none" },
        }}
      >
        Browse Insights
      </Button>
    </Paper>
  );
}

export default function PinnedInsightsSection({ pinnedIds, onTogglePin, onBrowseInsights }) {
  useRelativeTimeTick(30000); 
  const [openBreakdownId, setOpenBreakdownId] = useState(null); // moved above derived values

  const {   coderAccuracy, coderAccuracyLastUpdated,
    codeChanges, codeChangesLastUpdated,
    topDrg, topDrgLastUpdated,
    specialtyAuditOutcomes, specialtyAuditOutcomesLastUpdated,
    financialImpact, financialImpactLastUpdated,coderAccuracyLoading,codeChangesLoading,topDrgLoading,specialtyAuditOutcomesLoading,financialImpactLoading} =
    useSelector((state) => state.workflowDashboard);

  const pinnedInsights = pinnedIds
    .map((id) =>
      INSIGHTS_LOOKUP(id, {
        coderAccuracy, coderAccuracyLastUpdated,
        codeChanges, codeChangesLastUpdated,
        topDrg, topDrgLastUpdated,
        specialtyAuditOutcomes, specialtyAuditOutcomesLastUpdated,
        financialImpact, financialImpactLastUpdated,
      }),
    )
    .filter(Boolean);

  const canAddMore = pinnedInsights.length < MAX_PINNED_TILES;
    const LOADING_BY_ID = { 
    "coder-accuracy": coderAccuracyLoading,
    "diagnosis-changes": codeChangesLoading,
    "top-drg-changes": topDrgLoading,
    "specialty-audit-outcomes": specialtyAuditOutcomesLoading,
    "confirmed-financial-impact": financialImpactLoading,
  };

  return (
    <Box>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: TEXT_HEADING, mb: 1.5 }}>
        Personalized Dashboard
      </Typography>
       <Typography sx={{mb:1.5, fontSize: 12.5, color: TEXT_MUTED }}>
          Analytics you've added from the Insights tab.
        </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
          gap: { xs: 2, sm: 2.5 },
        }}
      >
        {pinnedInsights.map((insight) => (
          <InsightTile
            key={insight.id}
            insight={insight}
            pinned
            onTogglePin={onTogglePin}
            iconVariant="minus"
            onOpenBreakdown={setOpenBreakdownId}
            disableOpenBreakdown={false}
            loading={LOADING_BY_ID[insight.id] ?? false}
          />
        ))}

        {canAddMore && <AddMoreInsightsCard onBrowseInsights={onBrowseInsights} />}
      </Box>

      {/* added — renders whichever breakdown modal is currently open */}
      <BreakdownRouter
        openId={openBreakdownId}
        onClose={() => setOpenBreakdownId(null)}
        pinnedIds={pinnedIds}
        onTogglePin={onTogglePin}
      />
    </Box>
  );
}